enum BusinessRoutePath {
  NEW_USER_INTRO = '/new-user-intro',
  SELECT_BUSINESS_TYPE = '/select-business-type',
  CREATE_PROFILE = '/create-profile',
  CREATE_PROFILE_PAGE = '/create-profile/page',
  CREATE_PERSONAL_PROFILE_PAGE = '/create-personal-profile/page',
  CREATE_PERSONAL_PROFILE = '/create-personal-profile',
  PROFILE = '/profile',
  BANK_DETAILS = '/bank-details',
  UPDATE_BUSINESS_PROFILE = '/update-business-profile',
  UPDATE_BUSINESS_INFORMATION = '/update-business-information',
  UPDATE_BUSINESS_BANK_DETAILS = '/update-business-bank-details',
  REPAIR_PERSONAL_DETAIL = '/repair-personel-detail',
  REPAIR_PERSONAL_ADDRESS = '/repair-personel-address',
  UPDATE_REPAIR_CATEGORIES = '/update-repair-categories',
  UPDATE_REPAIR_LOCATIONS = '/update-repair-locations',
  REPAIR_VIEW_PRODUCT = '/view-product',
  REPAIR_CALENDAR = '/calendar',
  REPAIR_CALENDAR_DETAIL = '/calendarDetail',
  NOTIFICATIONS = '/repair-notifications',
  PAYMENT = '/payment',
  HISTORY = '/history',
}

export default BusinessRoutePath;
